// assets/load-more.js

document.addEventListener("DOMContentLoaded", () => {
  const loadMoreButton = document.getElementById("LoadMoreButton");
  const productGrid = document.querySelector(".collection-products");

  if (loadMoreButton && productGrid) {
    loadMoreButton.addEventListener("click", (e) => {
      e.preventDefault(); // Prevent the default link behavior
      loadMoreButton.innerText = "Loading...";
      const nextPageUrl = loadMoreButton.href;

      // Fetch the next page's HTML
      fetch(nextPageUrl)
        .then((response) => response.text())
        .then((html) => {
          // Parse the HTML string into a usable DOM object
          const tempDiv = document.createElement("div");
          tempDiv.innerHTML = html;

          // Find the product grid and products in the new HTML
          const newProducts = tempDiv.querySelector(".products-grid").innerHTML;
          const newLoadMoreButton = tempDiv.querySelector("#LoadMoreButton");

          // Append new products to the existing grid
          productGrid.insertAdjacentHTML("beforeend", newProducts);

          // Update the "Load More" button or hide it
          if (newLoadMoreButton) {
            loadMoreButton.href = newLoadMoreButton.href; // Update URL to the *next* page
            loadMoreButton.innerText = "Load more";
          } else {
            loadMoreButton.style.display = "none"; // Hide if no more pages
          }
        })
        .catch((error) => console.error("Error loading more products:", error));
    });
  }
});
